import {API, Setup} from '../../Services';


async function OnlineStoreHomeData(merchantId){
    let token =  localStorage.getItem('token');
    return API.get(`/shop/${merchantId}/page-public`);
}

export {OnlineStoreHomeData};
